/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Button, TextField, Grid } from '@material-ui/core';

import LocaleMessage from '~/components/LocaleMessage';

import { Column, SettingsArea } from '../styles';

/**
 * Settings component for the Cleaning Application.
 * Manages configuration for tank capacity, discharge rate, and dilution.
 */
export default function Settings({ app, updateObject }) {
    const { settings: appConfig } = app;

    const appSettings =
        appConfig && appConfig.settings ? appConfig.settings : {};

    const [config, setConfig] = useState(appSettings);

    const handleInputChange = (field, value) => {
        setConfig({
            ...config,
            [field]: value,
        });
    };

    const handleSubmit = () => {
        updateObject({ ...app, settings: config });
    };

    return (
        <Column>
            <SettingsArea className="row col-12 mt-5 mb-5">
                <Grid container spacing={3} style={{ padding: '20px' }}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            label={
                                <LocaleMessage msg="page.applications.cleaning.settings.dilution_ratio" />
                            }
                            value={config.chemical_dilution_ratio || ''}
                            onChange={e =>
                                handleInputChange(
                                    'chemical_dilution_ratio',
                                    e.target.value
                                )
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            type="number"
                            label={
                                <LocaleMessage msg="page.applications.cleaning.settings.human_productivity" />
                            }
                            value={config.human_productivity || ''}
                            onChange={e =>
                                handleInputChange(
                                    'human_productivity',
                                    e.target.value
                                )
                            }
                        />
                    </Grid>
                </Grid>

                <Button
                    className="col-md-8 col-12 p-3 mt-5"
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    onClick={handleSubmit}
                >
                    <LocaleMessage msg="button.save" />
                </Button>
            </SettingsArea>
        </Column>
    );
}

Settings.propTypes = {
    app: PropTypes.object.isRequired,
    updateObject: PropTypes.func.isRequired,
};
